class AnnouncementBarCountdown extends HTMLElement {
    constructor() {
      super();

      this.enableCountdown = this.dataset.enableCountdown;
      this.countdownYear = this.dataset.countdownYear;
      this.countdownMonth = this.dataset.countdownMonth;
      this.countdownDay = this.dataset.countdownDay;
      this.countdownHour = this.dataset.countdownHour;
      this.countdownMinute = this.dataset.countdownMinute;
      this.countdownSecond = this.dataset.countdownSecond;
      this.hideWhenDone = this.dataset.hideWhenDone;

      if (this.enableCountdown) {
        this.countdown();
      }
    }
    countdown(){
      let self = this,
          timerElement = self,
          countdownDate = self.countdownMonth + ' ' + self.countdownDay + ', ' + self.countdownYear + ' ' + self.countdownHour + ':' + self.countdownMinute + ':' + self.countdownSecond;

      let countDownDate = new Date(countdownDate).getTime();
      let x = setInterval(function() {
        let now = new Date().getTime(),
            distance = countDownDate - now,
            days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000),
            timerText = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        
        days == 0 ? timerText = hours + "h " + minutes + "m " + seconds + "s " : '';

        timerElement.innerHTML = timerText;

        if (distance < 0) {
          clearInterval(x);
          if (self.hideWhenDone == 'true') {
            self.closest(".announcement-bar__content").style.display = 'none'
            timerElement.innerHTML = "";
          } else{
            timerElement.innerHTML = "";
          }
        }
      }, 1000);
    }

  }
  
  customElements.define('announcement-bar-countdown', AnnouncementBarCountdown);
  